module.exports = __webpack_public_path__ + "img/gotomarker_right_mod.59dd4968.svg";